import React from "react";
import styled from "styled-components";

import type { AuthRole } from "../../types/auth";
import { pxToRem } from "../../styles/utils";

const Wrapper = styled.div`
  width: 100%;
  max-width: ${pxToRem(369)};
  margin: 0 auto ${({ theme }) => pxToRem(theme.spacing.lg)};
  text-align: left;
`;

const Label = styled.div`
  margin-bottom: ${({ theme }) => pxToRem(theme.spacing.xs)};
  color: ${({ theme }) => theme.colors.inkMuted};
  font-size: ${({ theme }) => pxToRem(theme.fontSize.xs)};
  font-weight: 500;
  line-height: 1.35;
`;

const SegmentedControl = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: ${({ theme }) => pxToRem(theme.spacing.xxs)};
  width: 100%;
  padding: ${({ theme }) => pxToRem(theme.spacing.xxs)};
  border-radius: ${({ theme }) => pxToRem(theme.radii.md)};
  background: ${({ theme }) => theme.colors.inkSurface};
`;

const RoleButton = styled.button<{ $active: boolean }>`
  min-height: ${({ theme }) => pxToRem(theme.controlHeight.sm)};
  padding: 0 ${({ theme }) => pxToRem(theme.spacing.md)};
  border: 0;
  border-radius: ${({ theme }) => pxToRem(theme.radii.md)};
  background: ${({ $active, theme }) => ($active ? theme.colors.white : "transparent")};
  color: ${({ $active, theme }) => ($active ? theme.colors.brand : theme.colors.inkSoft)};
  font: inherit;
  font-size: ${({ theme }) => pxToRem(theme.fontSize.sm)};
  font-weight: 600;
  cursor: pointer;
  box-shadow: ${({ $active, theme }) => ($active ? theme.shadows.sm : "none")};
  transition: background 0.15s ease, color 0.15s ease, box-shadow 0.15s ease;

  &:hover:not(:disabled) {
    color: ${({ theme }) => theme.colors.brand};
  }

  &:focus-visible {
    outline: ${pxToRem(2)} solid ${({ theme }) => theme.colors.brand};
    outline-offset: ${pxToRem(2)};
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }
`;

interface AuthRoleSwitchProps {
  value: AuthRole;
  onChange: (role: AuthRole) => void;
  disabled?: boolean;
  label?: string;
}

const AuthRoleSwitch: React.FC<AuthRoleSwitchProps> = ({
  value,
  onChange,
  disabled = false,
  label = "Тип аккаунта",
}) => (
  <Wrapper>
    <Label>{label}</Label>
    <SegmentedControl role="group" aria-label={label}>
      <RoleButton
        type="button"
        $active={value === "teacher"}
        aria-pressed={value === "teacher"}
        disabled={disabled}
        onClick={() => onChange("teacher")}
      >
        Преподаватель
      </RoleButton>
      <RoleButton
        type="button"
        $active={value === "student"}
        aria-pressed={value === "student"}
        disabled={disabled}
        onClick={() => onChange("student")}
      >
        Ученик
      </RoleButton>
    </SegmentedControl>
  </Wrapper>
);

export default AuthRoleSwitch;